import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './auth.interceptor';
import { AuthSessionService } from './auth-session.service';

/**
 * Called once at bootstrap. The JWT access token never survives a reload (it
 * is memory-only, by design - see token-store.ts), so without this an admin
 * with a JWT session falls back to their legacy token (or appears signed
 * out) on every page load instead of it being silently restored via the
 * refresh cookie.
 *
 * Uses the classic APP_INITIALIZER token rather than this app's usual
 * ENVIRONMENT_INITIALIZER convention (see core/navigation/navigation.provider.ts)
 * deliberately: restoreSession() does real async work (a network round trip)
 * that should complete before the app finishes bootstrapping, which is what
 * APP_INITIALIZER blocks on and ENVIRONMENT_INITIALIZER does not.
 */
export function restoreSessionFactory(auth: AuthSessionService) {
  return () => auth.restoreSession();
}

/** Token -> JWT migration: registers the auth interceptor and the
 * bootstrap session restore. Add this to app.config.ts's providers array. */
export function provideAuth(): Array<Provider | EnvironmentProviders> {
  return [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: restoreSessionFactory,
      deps: [AuthSessionService],
      multi: true
    }
  ];
}
